import { ConfigUtil } from '@mintdata-wsp/common/util/ConfigUtil';

const MAX_HOSTNAME_PART_LENGTH = 63;

export class PublishedAppUrlUtil
{
    public static getUrlPrefix(isBeta:boolean):string
    {
        const protocol = ConfigUtil.publishedAppsSecured() ? 'https' : 'http';
        return `${protocol}://${isBeta ? 'beta-' : ''}`;
    }

    public static getUrlPostfix(organizationSid:string):string
    {
        const publishedAppsHost = ConfigUtil.publishedAppsHost()
        return `-${organizationSid}.${publishedAppsHost}`;
    }

    public static getFullUrl(organizationSid:string, urlPart:string, isBeta:boolean)
    {
        return this.getUrlPrefix(isBeta) + urlPart + this.getUrlPostfix(organizationSid);
    }

    public static maxUrlPartLength(organizationSid:string, isBeta:boolean)
    {
        let maxLength = MAX_HOSTNAME_PART_LENGTH;
        if( isBeta )
            maxLength -= 'beta-'.length;

        // ... consider "-org" part
        maxLength -= organizationSid.length + 1;

        return maxLength;
    }
}
